/**
 * LoadingButton
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'semantic-ui-react';

// Selectors
import { makeSelectLoading } from '../../services/loading/selectors';

interface Props {
    children?: React.Node;
    loading: boolean;
}

export class LoadingButton extends React.PureComponent<Props> {
    render() {
        const { children, loading, dispatch, ...props } = this.props;
        if (!children) return null;
        return (
            <Button {...props} loading={loading}>
                {children}
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: makeSelectLoading()
});

export default connect(mapStateToProps)(LoadingButton);
